// extracted by mini-css-extract-plugin
export default {"container":"MainTabsModule_container__50Oxf","content":"MainTabsModule_content__NoCcM"};